var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIconGroupBy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.758363 8.49586C0.562225 8.5074 0.369331 8.44143 0.220356 8.31188C-0.073452 8.01289 -0.073452 7.52999 0.220356 7.23099L6.65379 0.72268C6.95937 0.433406 7.43889 0.449486 7.72483 0.758628C7.98341 1.03818 7.99848 1.46787 7.76012 1.76525L1.28878 8.31188C1.14173 8.43957 0.951931 8.5054 0.758363 8.49586Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18423 8.49586C6.98545 8.495 6.79493 8.41518 6.65379 8.27356L0.220331 1.76522C-0.0518668 1.44366 -0.01486 0.959724 0.303003 0.684334C0.586705 0.438555 1.00511 0.438555 1.28878 0.684334L7.76012 7.19265C8.06563 7.482 8.08143 7.96712 7.7954 8.27618C7.78402 8.28848 7.77227 8.30037 7.76012 8.31188C7.60166 8.45128 7.39312 8.5179 7.18423 8.49586Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconGroupBy);
export default __webpack_public_path__ + "static/media/CrossIconGroupBy.aee2d68d1ff9f2298cfb87bd2d8e776d.svg";
export { ForwardRef as ReactComponent };